import https,  { getApiConfig } from '../../utils/request'
import { RequestParams,ContentType, Method } from 'axios-mapper'
 
// 获取属性模板
export const getAttrTemplate = (id?:string|number) => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/category-template?category_id=${id}`, Method.GET, {})
}

// 视频列表 
export const getalbum = (params: RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/album`, Method.GET, params, ContentType.form)
}

// 视频/相册分类

export const getAlbumCategory = (date_str: String) => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/album-class?page=1&size=1000&s=${date_str}`, Method.GET, {})
}



// 图片上传路径
export const getUploadPath = (rand : string | number = '999') => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/upload/path?sa=${rand}`, Method.GET, {})
}

// 上传图片视频源文件
export const handleUploadPhoto = (data: RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/album`, Method.POST, data, ContentType.form)
}

//销售属性
export const getSellAttr = (data:RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/properties`, Method.GET, data, ContentType.form)
}

//属性值
export const getSellAttrValue = (data:RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/properties-value`, Method.POST, data)
}

//商品新增
export const addGoods = (data:any) => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/product/create`, Method.POST, data)
 }


  // 类目列表
export const getCategoryList = () => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/category`, Method.GET, {})
}

// 卖家商品列表
export const getGoodsList = (params: RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/goodslist`, Method.GET,params, ContentType.form)
}
 

//草稿箱新增
export const addGoodsdrafts = (data: RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/drafts/create`, Method.POST, data)
}



// 草稿箱列表

export const getDraftsList = (params: RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/drafts`, Method.GET,params, ContentType.form)
}

// 草稿箱删除列表数据

export const handleDeleteDrafts = (data: RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/drafts/delete/${data}`, Method.POST, {}, ContentType.form)
}

// 修改商品列表库存 
export const handleUpdateSkuData = (data: RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/sp-update`, Method.POST, data)
}

// 修改商品列表 价格
export const handleUpdateSkuDataPrice = (data: RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/product-storage/update`, Method.POST, data)
}

// 上下架
export const handleShelf = (data: RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/shelf-update`, Method.POST, data)
}

// Get gift by sku id
export const getGiftBySkuId = (sku_id: Number | String) => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/gifts/${sku_id}`, Method.GET)
}

// Submit gift datas with you sku id
export const postGiftBySku = (data: RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/gifts/create`, Method.POST, data)
}

// Get brand application datas
export const getBrandApplication = (data: RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/brand-application`, Method.GET, data, ContentType.form)
}

//编辑商品详情
export const editGoodsDetails = (data: RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/product-detail-edit/${data.product_sn}`, Method.GET)
}

//编辑商品
export const editGoodsUpdate = (data: RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/product/update`, Method.POST,data)
}
// Submit brand application datas
export const postBrandApplication = (data: RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/brand-application/create`, Method.POST, data, ContentType.json)
}

// 草稿箱详情
export const getDraftsDetails = (params: RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/drafts/${params.id}`, Method.GET,{})
}


// 草稿箱修改
export const getDraftsUpdate = (data: RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/drafts/update/${data.id}`, Method.POST, {product_name:data.product_name,product_data:data.product_data}, ContentType.json)
}


// 添加相册分类
export const addPhotoCate = (data: RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/album-class/create`, Method.POST, data)
}

//  获取上传视频信息.
export const getUPloadVideoInfo = (params: RequestParams) => {
  const api_config = getApiConfig()
return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/album-video`, Method.GET,params, ContentType.form)
}

//是否展示海关编码
export const getCustomsCode = () => {
  const api_config = getApiConfig()
return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/store`, Method.GET, )
}

//商品删除
export const getGoodsDelete = (data: RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/product/destroy`, Method.POST, data)
}

//商品删除
export const getGoodsShop = () => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/storeCategory`, Method.GET,)
}

//上传文件
export const uploadFiles = (data: RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.uploadUrl).request(`/file/fileUpload/v1.0/simpleFile`, Method.POST, data,ContentType.multipart)

}

//商品质量分
export const quality = (data: RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.manageUrl).request(`/basegoods/v1/operation/product/score_setting`, Method.GET)

}
//商品质量分
export const qualitySetting = (data: RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.manageUrl).request(`/basegoods/v1/operation/product/score_setting/update`,Method.POST, data)

}

// 批量改价上传文件
export const getBatchUploadFile = (data: RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.sellerUrl).request(`/apigoods/v1/${api_config.siteCode}/seller/product/price-excel`, Method.POST, data)
}




